import axios, { AxiosResponse } from 'axios';
import { REQUEST_EMAIL_CODE } from './endpoints';
import { CustomerNumber } from '../models/CustomerNumber';
import { LastName } from '../models/LastName';

export type RequestEmailCodeParams = {
  customerNumber: CustomerNumber;
  lastName: LastName;
};

export const requestEmailCode = (
  customerNumber: CustomerNumber,
  lastName: LastName,
  sourceContext: string | null,
) => {
  return axios.post<void, AxiosResponse<void>, RequestEmailCodeParams>(
    REQUEST_EMAIL_CODE,
    {
      customerNumber,
      lastName,
    },
    {
      headers: {
        'Source-Context': sourceContext,
      },
    },
  );
};
